<nav id="navbar" aria-label="Main navigation" class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top mb-5" [options]="options"
  Ngxheadroom [ngClass]="{ 'd-flex justify-content-between' : isMobile | async }">
  <button (click)="isCollapsed = !isCollapsed" class="navbar-toggler" type="button" data-toggle="collapse"
    data-target="#navbar-main" aria-controls="navbar-main" [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <a routerLink="/" aria-label="UNT Health Fort Worth Home">
    <img src="https://hsccdn.blob.core.windows.net/devcdn/unthealthlogo1.png" class="nav-img my-0 mr-md-auto navbar-brand" alt="UNT Health Fort Worth Logo" />
  </a>
  <div class="collapse navbar-collapse w-100" id="navbar-main" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
      <li class="nav-item mr-1">
        <a class="nav-link" routerLink="/" [ngClass]="{ 'pl-3' : isMobile | async }">Home</a>
      </li>
      <li class="nav-item mr-1">
        <a class="nav-link" routerLink="/directory" [ngClass]="{ 'pl-3' : isMobile | async }">Profile Search</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://unthealth.edu" target="_blank" rel="noopener noreferrer" [ngClass]="{ 'pl-3' : isMobile | async }">UNT Health Home<span class="sr-only"> (opens in new tab)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://experts.unthsc.edu" target="_blank" rel="noopener noreferrer" [ngClass]="{ 'pl-3' : isMobile | async }">UNT Health Research Profiles<span class="sr-only"> (opens in new tab)</span></a>
      </li>
    </ul>
  </div>
</nav>